export const REGIONS = {
  global: {
    id: 'global',
    title: 'Global / US',
    description: 'Data is processed and stored in the global Snoooz environment.',
    project: 'ooo-maker',
    appUrl: import.meta.env.VITE_GLOBAL_APP_URL || 'https://app.nudgefor.me',
  },
  eu: {
    id: 'eu',
    title: 'European Union',
    description: 'Data stays in the dedicated EU Snoooz environment.',
    project: 'ooo-maker-eu',
    appUrl: import.meta.env.VITE_EU_APP_URL || 'https://europe.nudgefor.me',
  },
};

export const CURRENT_REGION = import.meta.env.VITE_APP_REGION || 'local';

export function selectRegion(regionId) {
  if (!REGIONS[regionId]) throw new Error(`Unknown region: ${regionId}`);

  localStorage.setItem('nudge.region', regionId);

  const isLocal = CURRENT_REGION === 'local' || window.location.hostname === 'localhost';
  if (!isLocal && CURRENT_REGION !== regionId) {
    const target = new URL(REGIONS[regionId].appUrl);
    target.pathname = window.location.pathname;
    target.search = window.location.search;
    window.location.assign(target.toString());
    return { redirected: true };
  }

  return { redirected: false };
}
